import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import {
  IReviewFormDispatchProps,
  IReviewFormStoreProps,
  ISendFormDataOptions,
  ReviewForm,
} from '.';
import { IState } from '../../store';
import { reset, reviewRequest } from '../../store/review_request';
import { updateUserData } from '../../store/user';
import { isFromBuilder } from '../../utils/agent';
import { isPIKOffer } from '../../utils/offer_helpers';
import { getOfferType, isCommercial } from '../../utils/offer_type';

const mapStateToProps = (state: IState) => {
  const {
    offerData: {
      offer,
    },
  } = state;
  const offerType = getOfferType(offer);
  const isOfferCommercial = isCommercial(offerType);
  const currentUser = state.offerData.user;
  const phone = currentUser && currentUser.phones && currentUser.phones[0].phone;
  const name = currentUser ? `${currentUser.firstName || ''} ${currentUser.lastName || ''}` : '';

  return {
    email: currentUser && currentUser.email,
    isCommercial: isOfferCommercial,
    isFromBuilder: isFromBuilder(offer),
    isMessagingEnabled: Boolean(state.offerData.agent && state.offerData.agent.isMessagingEnabled),
    isPik: isPIKOffer(offer),
    name: name.trim(),
    phone,
    reviewRequestData: state.reviewRequest,
  };
};

const mapDispatchToProps = (dispatch: Dispatch<IState>) => ({
  resetReviewRequest: () => dispatch(reset()),
  reviewRequest: (options: ISendFormDataOptions) => dispatch(reviewRequest(options)),
  updateUserData: () => dispatch(updateUserData()),
});

export const ReviewFormContainer = connect<
  IReviewFormStoreProps,
  IReviewFormDispatchProps,
  {}
>(
  mapStateToProps,
  mapDispatchToProps,
)(ReviewForm);
